/* tslint:disable */
/* eslint-disable */
/**
 * datavolumes-service
 * An API for managing datavolumes
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@run.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * The ancestors of an org unit.
 * @export
 * @interface Ancestors
 */
export interface Ancestors {
    /**
     * 
     * @type {string}
     * @memberof Ancestors
     */
    'tenant_id': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Ancestors
     */
    'cluster_uuid'?: string | null;
    /**
     * The id of the department.
     * @type {string}
     * @memberof Ancestors
     */
    'department_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ancestors
     */
    'project_id'?: string | null;
}
/**
 * 
 * @export
 * @interface BaseFields
 */
export interface BaseFields {
    /**
     * 
     * @type {string}
     * @memberof BaseFields
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BaseFields
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseFields
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseFields
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseFields
     */
    'updatedBy'?: string;
}
/**
 * 
 * @export
 * @interface ComplianceIssues
 */
export interface ComplianceIssues {
    /**
     * 
     * @type {Array<ComplianceIssuesComplianceIssuesInner>}
     * @memberof ComplianceIssues
     */
    'complianceIssues'?: Array<ComplianceIssuesComplianceIssuesInner>;
}
/**
 * 
 * @export
 * @interface ComplianceIssuesComplianceIssuesInner
 */
export interface ComplianceIssuesComplianceIssuesInner {
    /**
     * 
     * @type {string}
     * @memberof ComplianceIssuesComplianceIssuesInner
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceIssuesComplianceIssuesInner
     */
    'details': string;
}
/**
 * 
 * @export
 * @interface Condition
 */
export interface Condition {
    /**
     * The type of the condition, such as Failed or Available. See Types of domain status conditions.
     * @type {string}
     * @memberof Condition
     */
    'type': string;
    /**
     * The status of the condition, such as True, False or Unknown.
     * @type {string}
     * @memberof Condition
     */
    'status': string;
    /**
     * An optional, human-readable message providing more details about the condition.
     * @type {string}
     * @memberof Condition
     */
    'message'?: string;
    /**
     * The reason for the Failed condition. Not applicable to other types of condition.
     * @type {string}
     * @memberof Condition
     */
    'reason'?: string;
    /**
     * A timestamp of when the condition was created or the last time time the condition transitioned from one status to another.
     * @type {string}
     * @memberof Condition
     */
    'lastTransitionTime'?: string | null;
}
/**
 * 
 * @export
 * @interface CountDatavolumes200Response
 */
export interface CountDatavolumes200Response {
    /**
     * 
     * @type {number}
     * @memberof CountDatavolumes200Response
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface Datavolume
 */
export interface Datavolume {
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'description'?: string;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof Datavolume
     */
    'originPvcName': string;
    /**
     * The ID of the project that in its namespace the origin pvc is located
     * @type {string}
     * @memberof Datavolume
     */
    'projectId': string;
    /**
     * True is not supported and will be removed in a future release
     * @type {boolean}
     * @memberof Datavolume
     */
    'shouldDeleteOriginalVolume'?: boolean;
    /**
     * If true, the original storage volume will be used together with the datavolume. default true as long as \"shouldDeleteOriginalVolume\" is not true
     * @type {boolean}
     * @memberof Datavolume
     */
    'shouldUseOriginalVolume'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof Datavolume
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Datavolume
     */
    'clusterId'?: string;
    /**
     * Will be returned only if the user has the required permissions to view those scopes
     * @type {Array<SharedScope>}
     * @memberof Datavolume
     */
    'sharedScopes'?: Array<SharedScope>;
    /**
     * 
     * @type {DatavolumeStatus}
     * @memberof Datavolume
     */
    'status': DatavolumeStatus;
}
/**
 * 
 * @export
 * @interface DatavolumeAllOf
 */
export interface DatavolumeAllOf {
    /**
     * Will be returned only if the user has the required permissions to view those scopes
     * @type {Array<SharedScope>}
     * @memberof DatavolumeAllOf
     */
    'sharedScopes'?: Array<SharedScope>;
    /**
     * 
     * @type {DatavolumeStatus}
     * @memberof DatavolumeAllOf
     */
    'status': DatavolumeStatus;
}
/**
 * 
 * @export
 * @interface DatavolumeCreationFields
 */
export interface DatavolumeCreationFields {
    /**
     * 
     * @type {string}
     * @memberof DatavolumeCreationFields
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeCreationFields
     */
    'description'?: string;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof DatavolumeCreationFields
     */
    'originPvcName': string;
    /**
     * The ID of the project that in its namespace the origin pvc is located
     * @type {string}
     * @memberof DatavolumeCreationFields
     */
    'projectId': string;
    /**
     * True is not supported and will be removed in a future release
     * @type {boolean}
     * @memberof DatavolumeCreationFields
     */
    'shouldDeleteOriginalVolume'?: boolean;
    /**
     * If true, the original storage volume will be used together with the datavolume. default true as long as \"shouldDeleteOriginalVolume\" is not true
     * @type {boolean}
     * @memberof DatavolumeCreationFields
     */
    'shouldUseOriginalVolume'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DatavolumeInnerFields
 */
export interface DatavolumeInnerFields {
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'description'?: string;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'originPvcName': string;
    /**
     * The ID of the project that in its namespace the origin pvc is located
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'projectId': string;
    /**
     * True is not supported and will be removed in a future release
     * @type {boolean}
     * @memberof DatavolumeInnerFields
     */
    'shouldDeleteOriginalVolume'?: boolean;
    /**
     * If true, the original storage volume will be used together with the datavolume. default true as long as \"shouldDeleteOriginalVolume\" is not true
     * @type {boolean}
     * @memberof DatavolumeInnerFields
     */
    'shouldUseOriginalVolume'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof DatavolumeInnerFields
     */
    'clusterId'?: string;
}
/**
 * 
 * @export
 * @interface DatavolumeInternal
 */
export interface DatavolumeInternal {
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'description'?: string;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'originPvcName': string;
    /**
     * The ID of the project that in its namespace the origin pvc is located
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'projectId': string;
    /**
     * True is not supported and will be removed in a future release
     * @type {boolean}
     * @memberof DatavolumeInternal
     */
    'shouldDeleteOriginalVolume'?: boolean;
    /**
     * If true, the original storage volume will be used together with the datavolume. default true as long as \"shouldDeleteOriginalVolume\" is not true
     * @type {boolean}
     * @memberof DatavolumeInternal
     */
    'shouldUseOriginalVolume'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof DatavolumeInternal
     */
    'clusterId'?: string;
    /**
     * Will be returned only if the user has the required permissions to view those scopes
     * @type {Array<SharedScope>}
     * @memberof DatavolumeInternal
     */
    'sharedScopes'?: Array<SharedScope>;
    /**
     * 
     * @type {DatavolumePhase}
     * @memberof DatavolumeInternal
     */
    'phase'?: DatavolumePhase;
}
/**
 * 
 * @export
 * @interface DatavolumeInternalAllOf
 */
export interface DatavolumeInternalAllOf {
    /**
     * Will be returned only if the user has the required permissions to view those scopes
     * @type {Array<SharedScope>}
     * @memberof DatavolumeInternalAllOf
     */
    'sharedScopes'?: Array<SharedScope>;
    /**
     * 
     * @type {DatavolumePhase}
     * @memberof DatavolumeInternalAllOf
     */
    'phase'?: DatavolumePhase;
}
/**
 * 
 * @export
 * @interface DatavolumeNoSharedScopes
 */
export interface DatavolumeNoSharedScopes {
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'description'?: string;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'originPvcName': string;
    /**
     * The ID of the project that in its namespace the origin pvc is located
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'projectId': string;
    /**
     * True is not supported and will be removed in a future release
     * @type {boolean}
     * @memberof DatavolumeNoSharedScopes
     */
    'shouldDeleteOriginalVolume'?: boolean;
    /**
     * If true, the original storage volume will be used together with the datavolume. default true as long as \"shouldDeleteOriginalVolume\" is not true
     * @type {boolean}
     * @memberof DatavolumeNoSharedScopes
     */
    'shouldUseOriginalVolume'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof DatavolumeNoSharedScopes
     */
    'clusterId'?: string;
    /**
     * 
     * @type {DatavolumeStatus}
     * @memberof DatavolumeNoSharedScopes
     */
    'status': DatavolumeStatus;
}
/**
 * 
 * @export
 * @interface DatavolumeNoSharedScopesAllOf
 */
export interface DatavolumeNoSharedScopesAllOf {
    /**
     * 
     * @type {DatavolumeStatus}
     * @memberof DatavolumeNoSharedScopesAllOf
     */
    'status': DatavolumeStatus;
}
/**
 * 
 * @export
 * @interface DatavolumePatchFields
 */
export interface DatavolumePatchFields {
    /**
     * 
     * @type {string}
     * @memberof DatavolumePatchFields
     */
    'description'?: string;
}
/**
 * Phase of the Datavolume in the cluster
 * @export
 * @enum {string}
 */

export const DatavolumePhase = {
    Ready: 'Ready',
    NotReady: 'NotReady',
    Creating: 'Creating',
    Deleting: 'Deleting',
    Unknown: 'Unknown'
} as const;

export type DatavolumePhase = typeof DatavolumePhase[keyof typeof DatavolumePhase];


/**
 * Which datavolumes to return in the GET datavolumes response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \"usableInProjectId\" query param.
 * @export
 * @enum {string}
 */

export const DatavolumeRequestType = {
    Originated: 'Originated',
    UsableInProject: 'UsableInProject'
} as const;

export type DatavolumeRequestType = typeof DatavolumeRequestType[keyof typeof DatavolumeRequestType];


/**
 * 
 * @export
 * @enum {string}
 */

export const DatavolumeSortFilterFields = {
    Name: 'name',
    ProjectId: 'projectId',
    ClusterId: 'clusterId',
    DepartmentId: 'departmentId',
    ProjectName: 'projectName',
    CreatedAt: 'createdAt',
    CreatedBy: 'createdBy',
    Phase: 'phase'
} as const;

export type DatavolumeSortFilterFields = typeof DatavolumeSortFilterFields[keyof typeof DatavolumeSortFilterFields];


/**
 * 
 * @export
 * @interface DatavolumeStatus
 */
export interface DatavolumeStatus {
    /**
     * 
     * @type {DatavolumePhase}
     * @memberof DatavolumeStatus
     */
    'phase': DatavolumePhase;
    /**
     * Message explaining the phase of the Datavolume in the cluster
     * @type {string}
     * @memberof DatavolumeStatus
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof DatavolumeStatus
     */
    'conditions'?: Array<Condition>;
    /**
     * The name of the copied PVC that is created in the cluster in the project namespace
     * @type {string}
     * @memberof DatavolumeStatus
     */
    'datavolumePvcName'?: string;
    /**
     * The name of the PV that is created in the cluster - copied from the one that was attached to the original pvc
     * @type {string}
     * @memberof DatavolumeStatus
     */
    'datavolumePvName'?: string;
}
/**
 * 
 * @export
 * @interface DatavolumeStatusForSync
 */
export interface DatavolumeStatusForSync {
    /**
     * 
     * @type {DatavolumePhase}
     * @memberof DatavolumeStatusForSync
     */
    'phase': DatavolumePhase;
    /**
     * Message explaining the phase of the Datavolume in the cluster
     * @type {string}
     * @memberof DatavolumeStatusForSync
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof DatavolumeStatusForSync
     */
    'conditions'?: Array<Condition>;
    /**
     * The name of the copied PVC that is created in the cluster in the project namespace
     * @type {string}
     * @memberof DatavolumeStatusForSync
     */
    'datavolumePvcName'?: string;
    /**
     * The name of the PV that is created in the cluster - copied from the one that was attached to the original pvc
     * @type {string}
     * @memberof DatavolumeStatusForSync
     */
    'datavolumePvName'?: string;
    /**
     * The id of the datavolume
     * @type {string}
     * @memberof DatavolumeStatusForSync
     */
    'datavolumeId': string;
}
/**
 * 
 * @export
 * @interface DatavolumeStatusForSyncAllOf
 */
export interface DatavolumeStatusForSyncAllOf {
    /**
     * The id of the datavolume
     * @type {string}
     * @memberof DatavolumeStatusForSyncAllOf
     */
    'datavolumeId': string;
}
/**
 * 
 * @export
 * @interface DatavolumeStatusInternal
 */
export interface DatavolumeStatusInternal {
    /**
     * 
     * @type {DatavolumePhase}
     * @memberof DatavolumeStatusInternal
     */
    'phase': DatavolumePhase;
    /**
     * Message explaining the phase of the Datavolume in the cluster
     * @type {string}
     * @memberof DatavolumeStatusInternal
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof DatavolumeStatusInternal
     */
    'conditions'?: Array<Condition>;
    /**
     * The name of the copied PVC that is created in the cluster in the project namespace
     * @type {string}
     * @memberof DatavolumeStatusInternal
     */
    'datavolumePvcName'?: string;
    /**
     * The name of the PV that is created in the cluster - copied from the one that was attached to the original pvc
     * @type {string}
     * @memberof DatavolumeStatusInternal
     */
    'datavolumePvName'?: string;
    /**
     * If true, the datavolume is deleted in the cluster and \'phase\' field is irrelevant.
     * @type {boolean}
     * @memberof DatavolumeStatusInternal
     */
    'isDeleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DatavolumeStatusInternalAllOf
 */
export interface DatavolumeStatusInternalAllOf {
    /**
     * If true, the datavolume is deleted in the cluster and \'phase\' field is irrelevant.
     * @type {boolean}
     * @memberof DatavolumeStatusInternalAllOf
     */
    'isDeleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DatavolumesSyncRequest
 */
export interface DatavolumesSyncRequest {
    /**
     * 
     * @type {Array<DatavolumeStatusForSync>}
     * @memberof DatavolumesSyncRequest
     */
    'datavolumes': Array<DatavolumeStatusForSync>;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof DatavolumesSyncRequest
     */
    'clusterId': string;
    /**
     * the first datavolume id to sync. if empty, all datavolumes before the first one sent will be deleted.
     * @type {string}
     * @memberof DatavolumesSyncRequest
     */
    'from'?: string;
    /**
     * the last datavolume to sync. if empty, all datavolumes after the last one sent will be deleted.
     * @type {string}
     * @memberof DatavolumesSyncRequest
     */
    'to'?: string;
}
/**
 * 
 * @export
 * @interface EnrichmentDataFields
 */
export interface EnrichmentDataFields {
    /**
     * 
     * @type {string}
     * @memberof EnrichmentDataFields
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof EnrichmentDataFields
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof EnrichmentDataFields
     */
    'clusterId'?: string;
}
/**
 * 
 * @export
 * @interface GetDatavolumes200Response
 */
export interface GetDatavolumes200Response {
    /**
     * 
     * @type {number}
     * @memberof GetDatavolumes200Response
     */
    'next'?: number;
    /**
     * 
     * @type {Array<DatavolumeNoSharedScopes>}
     * @memberof GetDatavolumes200Response
     */
    'datavolumes': Array<DatavolumeNoSharedScopes>;
}
/**
 * 
 * @export
 * @interface GetDatavolumesInternal200Response
 */
export interface GetDatavolumesInternal200Response {
    /**
     * 
     * @type {number}
     * @memberof GetDatavolumesInternal200Response
     */
    'next'?: number;
    /**
     * 
     * @type {Array<DatavolumeInternal>}
     * @memberof GetDatavolumesInternal200Response
     */
    'datavolumes': Array<DatavolumeInternal>;
}
/**
 * 
 * @export
 * @interface HttpResponse
 */
export interface HttpResponse {
    /**
     * 
     * @type {number}
     * @memberof HttpResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof HttpResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface InternalDatavolume
 */
export interface InternalDatavolume {
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolume
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolume
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolume
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolume
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolume
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolume
     */
    'name': string;
    /**
     * 
     * @type {ScopeType}
     * @memberof InternalDatavolume
     */
    'scope': ScopeType;
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolume
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof InternalDatavolume
     */
    'clusterId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolume
     */
    'description'?: string;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof InternalDatavolume
     */
    'originPvcName': string;
    /**
     * Will be returned only if the user has the required permissions to view those scopes
     * @type {Array<SharedScope>}
     * @memberof InternalDatavolume
     */
    'sharedScopes'?: Array<SharedScope>;
    /**
     * 
     * @type {DatavolumeStatus}
     * @memberof InternalDatavolume
     */
    'status': DatavolumeStatus;
}
/**
 * 
 * @export
 * @interface InternalDatavolumeCreationFields
 */
export interface InternalDatavolumeCreationFields {
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolumeCreationFields
     */
    'name': string;
    /**
     * 
     * @type {ScopeType}
     * @memberof InternalDatavolumeCreationFields
     */
    'scope': ScopeType;
    /**
     * The ID of the department that in its namespace the origin pvc is located (mandatory if scope is department)
     * @type {string}
     * @memberof InternalDatavolumeCreationFields
     */
    'departmentId'?: string;
    /**
     * The ID of the cluster that in its namespace the origin pvc is located (mandatory if scope is cluster)
     * @type {string}
     * @memberof InternalDatavolumeCreationFields
     */
    'clusterId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDatavolumeCreationFields
     */
    'description'?: string;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof InternalDatavolumeCreationFields
     */
    'originPvcName': string;
}
/**
 * 
 * @export
 * @interface InternalEnrichmentDataFields
 */
export interface InternalEnrichmentDataFields {
    /**
     * 
     * @type {string}
     * @memberof InternalEnrichmentDataFields
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof InternalEnrichmentDataFields
     */
    'clusterId'?: string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'details'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ScopeType = {
    Cluster: 'cluster',
    Department: 'department',
    Project: 'project'
} as const;

export type ScopeType = typeof ScopeType[keyof typeof ScopeType];


/**
 * 
 * @export
 * @interface SharedScope
 */
export interface SharedScope {
    /**
     * 
     * @type {ScopeType}
     * @memberof SharedScope
     */
    'scopeType': ScopeType;
    /**
     * 
     * @type {string}
     * @memberof SharedScope
     */
    'scopeId': string;
    /**
     * The name of the scope
     * @type {string}
     * @memberof SharedScope
     */
    'scopeName': string;
    /**
     * 
     * @type {string}
     * @memberof SharedScope
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SharedScope
     */
    'createdBy'?: string;
}
/**
 * 
 * @export
 * @interface SharedScopeAllOf
 */
export interface SharedScopeAllOf {
    /**
     * The name of the scope
     * @type {string}
     * @memberof SharedScopeAllOf
     */
    'scopeName': string;
    /**
     * 
     * @type {string}
     * @memberof SharedScopeAllOf
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SharedScopeAllOf
     */
    'createdBy'?: string;
}
/**
 * 
 * @export
 * @interface SharedScopeBase
 */
export interface SharedScopeBase {
    /**
     * 
     * @type {ScopeType}
     * @memberof SharedScopeBase
     */
    'scopeType': ScopeType;
    /**
     * 
     * @type {string}
     * @memberof SharedScopeBase
     */
    'scopeId': string;
}
/**
 * 
 * @export
 * @interface SharedScopesPatchRequest
 */
export interface SharedScopesPatchRequest {
    /**
     * 
     * @type {Array<SharedScopeBase>}
     * @memberof SharedScopesPatchRequest
     */
    'add'?: Array<SharedScopeBase>;
    /**
     * 
     * @type {Array<SharedScopeBase>}
     * @memberof SharedScopesPatchRequest
     */
    'remove'?: Array<SharedScopeBase>;
}
/**
 * 
 * @export
 * @interface SubmissionError
 */
export interface SubmissionError {
    /**
     * 
     * @type {number}
     * @memberof SubmissionError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionError
     */
    'details'?: string;
    /**
     * 
     * @type {Array<ComplianceIssuesComplianceIssuesInner>}
     * @memberof SubmissionError
     */
    'complianceIssues'?: Array<ComplianceIssuesComplianceIssuesInner>;
}

/**
 * DatavolumesApi - axios parameter creator
 * @export
 */
export const DatavolumesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the number of data volumes.
         * @summary Count data volumes.
         * @param {DatavolumeRequestType} requestType Which datavolumes would be returned in the response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \&quot;usableInProjectId\&quot; query param.
         * @param {string} [usableInProjectId] Only when using \&quot;UsableInProject\&quot; requestType; Filter results for only datavolumes that are shared with - or originated in - the project.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x3D;&#x3D; Equals, !&#x3D; Not equals, &lt;&#x3D; Less than or equal, &gt;&#x3D; Greater than or equal, &#x3D;@ contains, !@ Does not contains, &#x3D;^ Starts with and &#x3D;$ Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x3D;&#x3D;, !&#x3D;, &lt;&#x3D; and &gt;&#x3D;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDatavolumes: async (requestType: DatavolumeRequestType, usableInProjectId?: string, filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestType' is not null or undefined
            assertParamExists('countDatavolumes', 'requestType', requestType)
            const localVarPath = `/api/v1/datavolumes/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (requestType !== undefined) {
                localVarQueryParameter['requestType'] = requestType;
            }

            if (usableInProjectId !== undefined) {
                localVarQueryParameter['usableInProjectId'] = usableInProjectId;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a datavolume
         * @param {DatavolumeCreationFields} datavolumeCreationFields The datavolume to create.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatavolume: async (datavolumeCreationFields: DatavolumeCreationFields, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datavolumeCreationFields' is not null or undefined
            assertParamExists('createDatavolume', 'datavolumeCreationFields', datavolumeCreationFields)
            const localVarPath = `/api/v1/datavolumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datavolumeCreationFields, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatavolume: async (datavolumeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datavolumeId' is not null or undefined
            assertParamExists('deleteDatavolume', 'datavolumeId', datavolumeId)
            const localVarPath = `/api/v1/datavolumes/{datavolumeId}`
                .replace(`{${"datavolumeId"}}`, encodeURIComponent(String(datavolumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolume: async (datavolumeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datavolumeId' is not null or undefined
            assertParamExists('getDatavolume', 'datavolumeId', datavolumeId)
            const localVarPath = `/api/v1/datavolumes/{datavolumeId}`
                .replace(`{${"datavolumeId"}}`, encodeURIComponent(String(datavolumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the datavolume ancestors
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolumeAncestors: async (datavolumeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datavolumeId' is not null or undefined
            assertParamExists('getDatavolumeAncestors', 'datavolumeId', datavolumeId)
            const localVarPath = `/internal/datavolumes/{datavolumeId}/ancestors`
                .replace(`{${"datavolumeId"}}`, encodeURIComponent(String(datavolumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the datavolume\'s shared scopes
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolumeSharedScopes: async (datavolumeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datavolumeId' is not null or undefined
            assertParamExists('getDatavolumeSharedScopes', 'datavolumeId', datavolumeId)
            const localVarPath = `/api/v1/datavolumes/{datavolumeId}/sharedScopes`
                .replace(`{${"datavolumeId"}}`, encodeURIComponent(String(datavolumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get requested datavolumes.
         * @summary List datavolumes in permitted scopes
         * @param {DatavolumeRequestType} requestType Which datavolumes would be returned in the response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \&quot;usableInProjectId\&quot; query param.
         * @param {string} [usableInProjectId] Only when using \&quot;UsableInProject\&quot; requestType; Filter results for only datavolumes that are shared with - or originated in - the project.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'name' | 'projectId' | 'clusterId' | 'departmentId' | 'projectName' | 'createdAt' | 'createdBy' | 'phase'} [sortBy] Sort results by a parameters.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x3D;&#x3D; Equals, !&#x3D; Not equals, &lt;&#x3D; Less than or equal, &gt;&#x3D; Greater than or equal, &#x3D;@ contains, !@ Does not contains, &#x3D;^ Starts with and &#x3D;$ Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x3D;&#x3D;, !&#x3D;, &lt;&#x3D; and &gt;&#x3D;.
         * @param {string} [search] Filter results by a free text search.
         * @param {boolean} [includeInternal] Whether the query should include data volumes that were created internally
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolumes: async (requestType: DatavolumeRequestType, usableInProjectId?: string, offset?: number, limit?: number, sortBy?: 'name' | 'projectId' | 'clusterId' | 'departmentId' | 'projectName' | 'createdAt' | 'createdBy' | 'phase', sortOrder?: 'asc' | 'desc', filterBy?: Array<string>, search?: string, includeInternal?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestType' is not null or undefined
            assertParamExists('getDatavolumes', 'requestType', requestType)
            const localVarPath = `/api/v1/datavolumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (requestType !== undefined) {
                localVarQueryParameter['requestType'] = requestType;
            }

            if (usableInProjectId !== undefined) {
                localVarQueryParameter['usableInProjectId'] = usableInProjectId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (includeInternal !== undefined) {
                localVarQueryParameter['includeInternal'] = includeInternal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all datavolumes in cluster with all shared scopes - used by the agent for the k8s cluster.
         * @summary List datavolumes in cluster.
         * @param {string} clusterId The id of the cluster
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolumesInternal: async (clusterId: string, offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('getDatavolumesInternal', 'clusterId', clusterId)
            const localVarPath = `/api/v1/datavolumes/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a datavolume
         * @param {InternalDatavolumeCreationFields} internalDatavolumeCreationFields The datavolume to create.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCreateDatavolume: async (internalDatavolumeCreationFields: InternalDatavolumeCreationFields, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalDatavolumeCreationFields' is not null or undefined
            assertParamExists('internalCreateDatavolume', 'internalDatavolumeCreationFields', internalDatavolumeCreationFields)
            const localVarPath = `/internal/datavolumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalDatavolumeCreationFields, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {DatavolumePatchFields} datavolumePatchFields Datavolume to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDatavolume: async (datavolumeId: string, datavolumePatchFields: DatavolumePatchFields, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datavolumeId' is not null or undefined
            assertParamExists('patchDatavolume', 'datavolumeId', datavolumeId)
            // verify required parameter 'datavolumePatchFields' is not null or undefined
            assertParamExists('patchDatavolume', 'datavolumePatchFields', datavolumePatchFields)
            const localVarPath = `/api/v1/datavolumes/{datavolumeId}`
                .replace(`{${"datavolumeId"}}`, encodeURIComponent(String(datavolumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datavolumePatchFields, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch the datavolume\'s shared scopes
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {SharedScopesPatchRequest} sharedScopesPatchRequest Requested SharedScopes of the datavolume to patch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDatavolumeSharedScopes: async (datavolumeId: string, sharedScopesPatchRequest: SharedScopesPatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datavolumeId' is not null or undefined
            assertParamExists('patchDatavolumeSharedScopes', 'datavolumeId', datavolumeId)
            // verify required parameter 'sharedScopesPatchRequest' is not null or undefined
            assertParamExists('patchDatavolumeSharedScopes', 'sharedScopesPatchRequest', sharedScopesPatchRequest)
            const localVarPath = `/api/v1/datavolumes/{datavolumeId}/sharedScopes`
                .replace(`{${"datavolumeId"}}`, encodeURIComponent(String(datavolumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sharedScopesPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync all datavolumes statuses from k8s cluster to Run:AI control-plane.
         * @summary Sync the statuses of the datavolumes in the cluster
         * @param {DatavolumesSyncRequest} [datavolumesSyncRequest] The statuses to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDatavolumes: async (datavolumesSyncRequest?: DatavolumesSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/datavolumes/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datavolumesSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the status of the datavolume form the cluster
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {DatavolumeStatusInternal} datavolumeStatusInternal The status of the datavolume in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatavolumeStatus: async (datavolumeId: string, datavolumeStatusInternal: DatavolumeStatusInternal, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datavolumeId' is not null or undefined
            assertParamExists('updateDatavolumeStatus', 'datavolumeId', datavolumeId)
            // verify required parameter 'datavolumeStatusInternal' is not null or undefined
            assertParamExists('updateDatavolumeStatus', 'datavolumeStatusInternal', datavolumeStatusInternal)
            const localVarPath = `/api/v1/datavolumes/{datavolumeId}/status`
                .replace(`{${"datavolumeId"}}`, encodeURIComponent(String(datavolumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datavolumeStatusInternal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatavolumesApi - functional programming interface
 * @export
 */
export const DatavolumesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatavolumesApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the number of data volumes.
         * @summary Count data volumes.
         * @param {DatavolumeRequestType} requestType Which datavolumes would be returned in the response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \&quot;usableInProjectId\&quot; query param.
         * @param {string} [usableInProjectId] Only when using \&quot;UsableInProject\&quot; requestType; Filter results for only datavolumes that are shared with - or originated in - the project.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x3D;&#x3D; Equals, !&#x3D; Not equals, &lt;&#x3D; Less than or equal, &gt;&#x3D; Greater than or equal, &#x3D;@ contains, !@ Does not contains, &#x3D;^ Starts with and &#x3D;$ Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x3D;&#x3D;, !&#x3D;, &lt;&#x3D; and &gt;&#x3D;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countDatavolumes(requestType: DatavolumeRequestType, usableInProjectId?: string, filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountDatavolumes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countDatavolumes(requestType, usableInProjectId, filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a datavolume
         * @param {DatavolumeCreationFields} datavolumeCreationFields The datavolume to create.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDatavolume(datavolumeCreationFields: DatavolumeCreationFields, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Datavolume>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDatavolume(datavolumeCreationFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDatavolume(datavolumeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDatavolume(datavolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatavolume(datavolumeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Datavolume>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatavolume(datavolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the datavolume ancestors
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatavolumeAncestors(datavolumeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ancestors>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatavolumeAncestors(datavolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the datavolume\'s shared scopes
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatavolumeSharedScopes(datavolumeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SharedScope>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatavolumeSharedScopes(datavolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get requested datavolumes.
         * @summary List datavolumes in permitted scopes
         * @param {DatavolumeRequestType} requestType Which datavolumes would be returned in the response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \&quot;usableInProjectId\&quot; query param.
         * @param {string} [usableInProjectId] Only when using \&quot;UsableInProject\&quot; requestType; Filter results for only datavolumes that are shared with - or originated in - the project.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'name' | 'projectId' | 'clusterId' | 'departmentId' | 'projectName' | 'createdAt' | 'createdBy' | 'phase'} [sortBy] Sort results by a parameters.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x3D;&#x3D; Equals, !&#x3D; Not equals, &lt;&#x3D; Less than or equal, &gt;&#x3D; Greater than or equal, &#x3D;@ contains, !@ Does not contains, &#x3D;^ Starts with and &#x3D;$ Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x3D;&#x3D;, !&#x3D;, &lt;&#x3D; and &gt;&#x3D;.
         * @param {string} [search] Filter results by a free text search.
         * @param {boolean} [includeInternal] Whether the query should include data volumes that were created internally
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatavolumes(requestType: DatavolumeRequestType, usableInProjectId?: string, offset?: number, limit?: number, sortBy?: 'name' | 'projectId' | 'clusterId' | 'departmentId' | 'projectName' | 'createdAt' | 'createdBy' | 'phase', sortOrder?: 'asc' | 'desc', filterBy?: Array<string>, search?: string, includeInternal?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatavolumes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatavolumes(requestType, usableInProjectId, offset, limit, sortBy, sortOrder, filterBy, search, includeInternal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all datavolumes in cluster with all shared scopes - used by the agent for the k8s cluster.
         * @summary List datavolumes in cluster.
         * @param {string} clusterId The id of the cluster
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatavolumesInternal(clusterId: string, offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatavolumesInternal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatavolumesInternal(clusterId, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a datavolume
         * @param {InternalDatavolumeCreationFields} internalDatavolumeCreationFields The datavolume to create.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalCreateDatavolume(internalDatavolumeCreationFields: InternalDatavolumeCreationFields, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalDatavolume>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalCreateDatavolume(internalDatavolumeCreationFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patch datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {DatavolumePatchFields} datavolumePatchFields Datavolume to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDatavolume(datavolumeId: string, datavolumePatchFields: DatavolumePatchFields, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatavolumeNoSharedScopes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDatavolume(datavolumeId, datavolumePatchFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patch the datavolume\'s shared scopes
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {SharedScopesPatchRequest} sharedScopesPatchRequest Requested SharedScopes of the datavolume to patch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDatavolumeSharedScopes(datavolumeId: string, sharedScopesPatchRequest: SharedScopesPatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SharedScope>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDatavolumeSharedScopes(datavolumeId, sharedScopesPatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sync all datavolumes statuses from k8s cluster to Run:AI control-plane.
         * @summary Sync the statuses of the datavolumes in the cluster
         * @param {DatavolumesSyncRequest} [datavolumesSyncRequest] The statuses to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncDatavolumes(datavolumesSyncRequest?: DatavolumesSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncDatavolumes(datavolumesSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the status of the datavolume form the cluster
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {DatavolumeStatusInternal} datavolumeStatusInternal The status of the datavolume in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatavolumeStatus(datavolumeId: string, datavolumeStatusInternal: DatavolumeStatusInternal, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatavolumeStatus(datavolumeId, datavolumeStatusInternal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DatavolumesApi - factory interface
 * @export
 */
export const DatavolumesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatavolumesApiFp(configuration)
    return {
        /**
         * Retrieve the number of data volumes.
         * @summary Count data volumes.
         * @param {DatavolumeRequestType} requestType Which datavolumes would be returned in the response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \&quot;usableInProjectId\&quot; query param.
         * @param {string} [usableInProjectId] Only when using \&quot;UsableInProject\&quot; requestType; Filter results for only datavolumes that are shared with - or originated in - the project.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x3D;&#x3D; Equals, !&#x3D; Not equals, &lt;&#x3D; Less than or equal, &gt;&#x3D; Greater than or equal, &#x3D;@ contains, !@ Does not contains, &#x3D;^ Starts with and &#x3D;$ Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x3D;&#x3D;, !&#x3D;, &lt;&#x3D; and &gt;&#x3D;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDatavolumes(requestType: DatavolumeRequestType, usableInProjectId?: string, filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<CountDatavolumes200Response> {
            return localVarFp.countDatavolumes(requestType, usableInProjectId, filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a datavolume
         * @param {DatavolumeCreationFields} datavolumeCreationFields The datavolume to create.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatavolume(datavolumeCreationFields: DatavolumeCreationFields, options?: any): AxiosPromise<Datavolume> {
            return localVarFp.createDatavolume(datavolumeCreationFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatavolume(datavolumeId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteDatavolume(datavolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolume(datavolumeId: string, options?: any): AxiosPromise<Datavolume> {
            return localVarFp.getDatavolume(datavolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the datavolume ancestors
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolumeAncestors(datavolumeId: string, options?: any): AxiosPromise<Ancestors> {
            return localVarFp.getDatavolumeAncestors(datavolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the datavolume\'s shared scopes
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolumeSharedScopes(datavolumeId: string, options?: any): AxiosPromise<Array<SharedScope>> {
            return localVarFp.getDatavolumeSharedScopes(datavolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get requested datavolumes.
         * @summary List datavolumes in permitted scopes
         * @param {DatavolumeRequestType} requestType Which datavolumes would be returned in the response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \&quot;usableInProjectId\&quot; query param.
         * @param {string} [usableInProjectId] Only when using \&quot;UsableInProject\&quot; requestType; Filter results for only datavolumes that are shared with - or originated in - the project.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'name' | 'projectId' | 'clusterId' | 'departmentId' | 'projectName' | 'createdAt' | 'createdBy' | 'phase'} [sortBy] Sort results by a parameters.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x3D;&#x3D; Equals, !&#x3D; Not equals, &lt;&#x3D; Less than or equal, &gt;&#x3D; Greater than or equal, &#x3D;@ contains, !@ Does not contains, &#x3D;^ Starts with and &#x3D;$ Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x3D;&#x3D;, !&#x3D;, &lt;&#x3D; and &gt;&#x3D;.
         * @param {string} [search] Filter results by a free text search.
         * @param {boolean} [includeInternal] Whether the query should include data volumes that were created internally
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolumes(requestType: DatavolumeRequestType, usableInProjectId?: string, offset?: number, limit?: number, sortBy?: 'name' | 'projectId' | 'clusterId' | 'departmentId' | 'projectName' | 'createdAt' | 'createdBy' | 'phase', sortOrder?: 'asc' | 'desc', filterBy?: Array<string>, search?: string, includeInternal?: boolean, options?: any): AxiosPromise<GetDatavolumes200Response> {
            return localVarFp.getDatavolumes(requestType, usableInProjectId, offset, limit, sortBy, sortOrder, filterBy, search, includeInternal, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all datavolumes in cluster with all shared scopes - used by the agent for the k8s cluster.
         * @summary List datavolumes in cluster.
         * @param {string} clusterId The id of the cluster
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatavolumesInternal(clusterId: string, offset?: number, limit?: number, options?: any): AxiosPromise<GetDatavolumesInternal200Response> {
            return localVarFp.getDatavolumesInternal(clusterId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a datavolume
         * @param {InternalDatavolumeCreationFields} internalDatavolumeCreationFields The datavolume to create.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCreateDatavolume(internalDatavolumeCreationFields: InternalDatavolumeCreationFields, options?: any): AxiosPromise<InternalDatavolume> {
            return localVarFp.internalCreateDatavolume(internalDatavolumeCreationFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch datavolume
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {DatavolumePatchFields} datavolumePatchFields Datavolume to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDatavolume(datavolumeId: string, datavolumePatchFields: DatavolumePatchFields, options?: any): AxiosPromise<DatavolumeNoSharedScopes> {
            return localVarFp.patchDatavolume(datavolumeId, datavolumePatchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch the datavolume\'s shared scopes
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {SharedScopesPatchRequest} sharedScopesPatchRequest Requested SharedScopes of the datavolume to patch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDatavolumeSharedScopes(datavolumeId: string, sharedScopesPatchRequest: SharedScopesPatchRequest, options?: any): AxiosPromise<Array<SharedScope>> {
            return localVarFp.patchDatavolumeSharedScopes(datavolumeId, sharedScopesPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sync all datavolumes statuses from k8s cluster to Run:AI control-plane.
         * @summary Sync the statuses of the datavolumes in the cluster
         * @param {DatavolumesSyncRequest} [datavolumesSyncRequest] The statuses to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDatavolumes(datavolumesSyncRequest?: DatavolumesSyncRequest, options?: any): AxiosPromise<void> {
            return localVarFp.syncDatavolumes(datavolumesSyncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the status of the datavolume form the cluster
         * @param {string} datavolumeId The id of the datavolume to retrieve
         * @param {DatavolumeStatusInternal} datavolumeStatusInternal The status of the datavolume in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatavolumeStatus(datavolumeId: string, datavolumeStatusInternal: DatavolumeStatusInternal, options?: any): AxiosPromise<void> {
            return localVarFp.updateDatavolumeStatus(datavolumeId, datavolumeStatusInternal, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatavolumesApi - object-oriented interface
 * @export
 * @class DatavolumesApi
 * @extends {BaseAPI}
 */
export class DatavolumesApi extends BaseAPI {
    /**
     * Retrieve the number of data volumes.
     * @summary Count data volumes.
     * @param {DatavolumeRequestType} requestType Which datavolumes would be returned in the response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \&quot;usableInProjectId\&quot; query param.
     * @param {string} [usableInProjectId] Only when using \&quot;UsableInProject\&quot; requestType; Filter results for only datavolumes that are shared with - or originated in - the project.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x3D;&#x3D; Equals, !&#x3D; Not equals, &lt;&#x3D; Less than or equal, &gt;&#x3D; Greater than or equal, &#x3D;@ contains, !@ Does not contains, &#x3D;^ Starts with and &#x3D;$ Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x3D;&#x3D;, !&#x3D;, &lt;&#x3D; and &gt;&#x3D;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public countDatavolumes(requestType: DatavolumeRequestType, usableInProjectId?: string, filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).countDatavolumes(requestType, usableInProjectId, filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a datavolume
     * @param {DatavolumeCreationFields} datavolumeCreationFields The datavolume to create.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public createDatavolume(datavolumeCreationFields: DatavolumeCreationFields, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).createDatavolume(datavolumeCreationFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete datavolume
     * @param {string} datavolumeId The id of the datavolume to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public deleteDatavolume(datavolumeId: string, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).deleteDatavolume(datavolumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get datavolume
     * @param {string} datavolumeId The id of the datavolume to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public getDatavolume(datavolumeId: string, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).getDatavolume(datavolumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the datavolume ancestors
     * @param {string} datavolumeId The id of the datavolume to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public getDatavolumeAncestors(datavolumeId: string, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).getDatavolumeAncestors(datavolumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the datavolume\'s shared scopes
     * @param {string} datavolumeId The id of the datavolume to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public getDatavolumeSharedScopes(datavolumeId: string, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).getDatavolumeSharedScopes(datavolumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get requested datavolumes.
     * @summary List datavolumes in permitted scopes
     * @param {DatavolumeRequestType} requestType Which datavolumes would be returned in the response. Originated - datavolumes that are originated in the permitted scopes of the caller. UsableInProject - datavolumes that can be used in a specific project; if you use this value, you must also provide the project ID in the \&quot;usableInProjectId\&quot; query param.
     * @param {string} [usableInProjectId] Only when using \&quot;UsableInProject\&quot; requestType; Filter results for only datavolumes that are shared with - or originated in - the project.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'name' | 'projectId' | 'clusterId' | 'departmentId' | 'projectName' | 'createdAt' | 'createdBy' | 'phase'} [sortBy] Sort results by a parameters.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x3D;&#x3D; Equals, !&#x3D; Not equals, &lt;&#x3D; Less than or equal, &gt;&#x3D; Greater than or equal, &#x3D;@ contains, !@ Does not contains, &#x3D;^ Starts with and &#x3D;$ Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x3D;&#x3D;, !&#x3D;, &lt;&#x3D; and &gt;&#x3D;.
     * @param {string} [search] Filter results by a free text search.
     * @param {boolean} [includeInternal] Whether the query should include data volumes that were created internally
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public getDatavolumes(requestType: DatavolumeRequestType, usableInProjectId?: string, offset?: number, limit?: number, sortBy?: 'name' | 'projectId' | 'clusterId' | 'departmentId' | 'projectName' | 'createdAt' | 'createdBy' | 'phase', sortOrder?: 'asc' | 'desc', filterBy?: Array<string>, search?: string, includeInternal?: boolean, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).getDatavolumes(requestType, usableInProjectId, offset, limit, sortBy, sortOrder, filterBy, search, includeInternal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all datavolumes in cluster with all shared scopes - used by the agent for the k8s cluster.
     * @summary List datavolumes in cluster.
     * @param {string} clusterId The id of the cluster
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public getDatavolumesInternal(clusterId: string, offset?: number, limit?: number, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).getDatavolumesInternal(clusterId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a datavolume
     * @param {InternalDatavolumeCreationFields} internalDatavolumeCreationFields The datavolume to create.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public internalCreateDatavolume(internalDatavolumeCreationFields: InternalDatavolumeCreationFields, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).internalCreateDatavolume(internalDatavolumeCreationFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch datavolume
     * @param {string} datavolumeId The id of the datavolume to retrieve
     * @param {DatavolumePatchFields} datavolumePatchFields Datavolume to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public patchDatavolume(datavolumeId: string, datavolumePatchFields: DatavolumePatchFields, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).patchDatavolume(datavolumeId, datavolumePatchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch the datavolume\'s shared scopes
     * @param {string} datavolumeId The id of the datavolume to retrieve
     * @param {SharedScopesPatchRequest} sharedScopesPatchRequest Requested SharedScopes of the datavolume to patch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public patchDatavolumeSharedScopes(datavolumeId: string, sharedScopesPatchRequest: SharedScopesPatchRequest, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).patchDatavolumeSharedScopes(datavolumeId, sharedScopesPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync all datavolumes statuses from k8s cluster to Run:AI control-plane.
     * @summary Sync the statuses of the datavolumes in the cluster
     * @param {DatavolumesSyncRequest} [datavolumesSyncRequest] The statuses to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public syncDatavolumes(datavolumesSyncRequest?: DatavolumesSyncRequest, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).syncDatavolumes(datavolumesSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the status of the datavolume form the cluster
     * @param {string} datavolumeId The id of the datavolume to retrieve
     * @param {DatavolumeStatusInternal} datavolumeStatusInternal The status of the datavolume in the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatavolumesApi
     */
    public updateDatavolumeStatus(datavolumeId: string, datavolumeStatusInternal: DatavolumeStatusInternal, options?: AxiosRequestConfig) {
        return DatavolumesApiFp(this.configuration).updateDatavolumeStatus(datavolumeId, datavolumeStatusInternal, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: any): AxiosPromise<void> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public health(options?: AxiosRequestConfig) {
        return HealthApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }
}


